const { checkPermission } = require("src/slices/users");
const { useSelector } = require("src/store");
import { reportDenied } from "src/utils/permissionDebugStore";

export function useCanDo(module) {
  const { adminMode } = useSelector((state) => state.settings);
  const { currentCustomer } = useSelector((state) => state.customers);
  const { user } = useSelector((state) => state.users);

  const canDo = (action, mod) => {
    const result =
      adminMode &&
      checkPermission({
        user: user,
        action: action,
        module: mod || module,
        customerId: currentCustomer?.id || null,
      });
    // Only report denials when adminMode is on — the guard is aimed at support staff
    if (!result && adminMode) {
      reportDenied(action, mod || module);
    }
    return result;
  };
  return {
    canDo: canDo,
  };
}
